<template>
    <button type="button" style="display: none;" data-bs-toggle="modal" data-bs-target="#cardNameModal" id="cardNameModalBTN"></button>
    <div class="modal fade" id="cardNameModal" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-dialog-centered">
            <!-- Modal content-->
            <div class="modal-content ">
                <div class="modal-body ">
                    <div class="mb-3">
                        <label class="form-label">نامی برای این شماره انتخاب کنید</label>
                        <input type="text" maxlength="14" class="form-control" style="direction:rtl" v-model="cardName" placeholder="مثلا علی">
                        <small :class="{'text-denger': cardName.length > 14 }">{{ cardName.length }} از 14</small>
                    </div>
                    <div class="text-end">
                    <button class="btn btn-danger mx-1" data-bs-dismiss="modal"  id="cardNameCloseBTN">بستن</button>
                    <button class="btn btn-success" @click="setName">ذخیره</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <input type="hidden" id="cardNameMobile" />
    <input type="hidden" id="cardNameName" />
</template>

<script setup>
import {ref} from 'vue'
import { alertBox } from '@/composables/silverBox.js' 
import { useAuth } from '@/store/auth'
import { useCard } from '@/store/card'
import { convertToEnglish } from '@/composables/digits';
let auth = useAuth()
let card = useCard()
let cardName = ref('')
function setName(){
    let mobile = document.getElementById('cardNameMobile').value
    let name = document.getElementById('cardNameName').value
    if(cardName.value.length == 0){
        alertBox("لطفا نامی وارد کنید",'error')
    }else if(cardName.value.length > 14){
        alertBox("تعداد کاراکتر بیش از حد مجاز است",'error')
    }else{
        fetch('https://radap.ir/Backend/api/section/card/name.php?token='+auth.token+'&mobile='+convertToEnglish(mobile)+'&name='+cardName.value)
        .then(()=>{
            cardName.value = ''
            alertBox("نام جدید ثبت شد",'success',2)
            document.getElementById('cardNameCloseBTN').click()
            card.getMobileList()
        })
    }

}

</script>